import { ITextFieldProps, Label, Stack } from "@fluentui/react";
import React from "react";

import CLCheckbox, { ICustomCheckboxProps } from './Checkbox'
import CLTextField from './TextField'

interface ICheckBoxWithTextField {
    label: string;
    checkboxProps?: ICustomCheckboxProps;
    textFieldProps?: ITextFieldProps;
}

// https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/318861
const CheckBoxWithTextField: React.FunctionComponent<ICheckBoxWithTextField> = (props) => {
    return <Stack>
        <Label>{props.label}</Label>
        <Stack horizontal >
            <Stack.Item grow={1}>
                <CLTextField
                    {...props.textFieldProps}
                    styles={{ root: { width: '100%', border: '1px solid gray' } }}
                    onRenderPrefix={(textFieldProps, textFieldDefaultRender) => {
                        return <CLCheckbox {...props.checkboxProps} />;
                    }}
                    onClick={(event) => {
                        props?.checkboxProps?.onChange?.(event, true);
                    }}
                />
            </Stack.Item>
        </Stack>
    </Stack>
}

export default CheckBoxWithTextField;
